import { State } from '@hookstate/core';
import {
  INavigationState,
  initialNavigationState,
} from '@store/hookstate/navigation/navigation';
import { getDevice, IDeviceTypes } from '@utils/getDevice';
import { getViewport, IViewport } from '@utils/getViewport';

export function syncNavigationState(
  devices: IDeviceTypes,
  navigationState: State<INavigationState>,
) {
  const isMobile = devices === 'mobile';

  if (isMobile) {
    navigationState.offsetTop.set(0);
    navigationState.minLeft.set(0);
  } else {
    navigationState.offsetTop.set(initialNavigationState.offsetTop);
    navigationState.minLeft.set(initialNavigationState.minLeft);
    navigationState.navigationTab.set(initialNavigationState.navigationTab);
  }
}
export function validateMediaChange(change: IDeviceTypes): IDeviceTypes {
  const actual = getDevice();
  if (change === actual) {
    return change;
  }
  return actual;
}
export function validateViewportChange(change: IViewport): IViewport {
  const actual = getViewport();
  if (actual.height !== change.height || actual.width !== change.width) {
    return actual;
  }
  return change;
}
